"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCustomerToPayment = void 0;
const shared_1 = require("@getgreenline/shared");
const addCustomerToPayment = async ({ companyId, locationId, paymentId, customerId, }) => {
    return shared_1.axios.post(`/api/v1/companies/${companyId}/locations/${locationId}/payments/${paymentId}/customer`, {
        customerId,
    });
};
exports.addCustomerToPayment = addCustomerToPayment;
//# sourceMappingURL=payment.js.map